import { render, staticRenderFns } from "./LocalVideoControlButton.vue?vue&type=template&id=8d3fc85a&scoped=true"
import script from "./LocalVideoControlButton.vue?vue&type=script&lang=js"
export * from "./LocalVideoControlButton.vue?vue&type=script&lang=js"
import style0 from "./LocalVideoControlButton.vue?vue&type=style&index=0&id=8d3fc85a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3fc85a",
  null
  
)

export default component.exports